module.exports = __webpack_public_path__ + "static/media/img-mygood-thumb@3x.d5995867.png";